import React, { useState } from "react";
import { Layer, Stage } from "react-konva";

import AdditionalImageLayer from "./additionalImageLayer";
import BackGroundLayer from "./BackGroundLayer";
import WeekEndCanvasText from "./WeekEndCanvasText";
import DayOfTheWeekCanvasText from "./DayOfTheWeekCanvasText";

import TitleCanvasText from "./TitleCanvasText";
import { useTranslation } from "react-i18next";

type ImageCanvasProps = {
  stageRef: any;
  BGHue: number;
  BGVal: number;
  BackgourndSrc: any;
  DowTasks: any;
  DowY: number;
  weekFontSize: number;
  weekEndTaskY: number;
  weekEndY: any;
  AddingImgSrc: any;
  fontFamilyName: any;
  TitleX: any;
  TitleY: any;
  titleFontSize: any;
  titleText: string;
};

const ImageCanvas: React.FC<ImageCanvasProps> = ({
  stageRef,
  BGHue,
  BGVal,
  BackgourndSrc,
  DowTasks,
  DowY,
  weekFontSize,
  weekEndTaskY,
  weekEndY,
  AddingImgSrc,
  fontFamilyName,
  TitleX,
  TitleY,
  titleFontSize,
  titleText,
}) => {
  //画像追加用State
  const [additionalImageClicked, setaddImgClicked] = useState<boolean>(false);
  const { t } = useTranslation();
  const Dow: any = Object.entries(
    t("image.dayOfTheWeekArr", { returnObjects: true })
  );
  const WeekEnd: any = Object.entries(
    t("image.weekEndArr", { returnObjects: true })
  );
  React.useEffect(() => {
    //ImgSrcが変更されたら発火。
    setaddImgClicked(false);
  }, [AddingImgSrc]);
  const canvasWidth = 640;
  const canvasHeight = 360;
  return (
    <Stage
      ref={stageRef /*stageRef*/}
      width={canvasWidth}
      height={canvasHeight}
    >
      <Layer
        onClick={() => {
          setaddImgClicked(false);
        }}
        onTap={() => {
          setaddImgClicked(false);
        }}
      >
        <BackGroundLayer
          imageSrc={BackgourndSrc}
          width={canvasWidth}
          height={canvasHeight}
          hueVal={BGHue}
          hsvVal={BGVal}
        />
        <DayOfTheWeekCanvasText
          Dow={Dow}
          canvasWidth={canvasWidth}
          canvasHeight={canvasHeight}
          DowTasks={DowTasks}
          DowY={DowY}
          weekFontSize={weekFontSize}
          fontFamilyName={fontFamilyName}
        />

        <WeekEndCanvasText
          canvasWidth={canvasWidth}
          canvasHeight={canvasHeight}
          WeekEnd={WeekEnd}
          DowTasks={DowTasks}
          weekFontSize={weekFontSize}
          weekEndTaskY={weekEndTaskY}
          fontFamilyName={fontFamilyName}
          weekEndY={weekEndY}
        />

        <TitleCanvasText
          text={titleText}
          fontFamilyName={fontFamilyName}
          fontSize={titleFontSize}
          x={TitleX}
          y={TitleY}
        />
      </Layer>
      <Layer
        onClick={() => {
          setaddImgClicked(true);
        }}
        onTap={() => {
          setaddImgClicked(true);
        }}
      >
        <AdditionalImageLayer
          imageSrc={AddingImgSrc}
          ImgClicked={additionalImageClicked}
          canvasWidth={canvasWidth}
          canvasHeight={canvasHeight}
        ></AdditionalImageLayer>
      </Layer>
    </Stage>
  );
};
export default ImageCanvas;
